import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { ColorMode, createThemeController } from '@reflact/primeng-theme/mode';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    readonly mode = signal<ColorMode>('system');
    readonly options = [
        { label: $localize`:@@themeSystem:System`, value: 'system' },
        { label: $localize`:@@themeLight:Hell`, value: 'light' },
        { label: $localize`:@@themeDark:Dunkel`, value: 'dark' }
    ];
    private readonly controller = createThemeController(mode => this.mode.set(mode));

    constructor() {
        inject(DestroyRef).onDestroy(() => this.controller.destroy());
    }

    setMode(mode: ColorMode): void {
        this.controller.setMode(mode);
    }
}
